import React from "react";
import { NavLogo } from "./navigation/NavLogo";
import { DesktopNav } from "./navigation/DesktopNav";
import { MobileNav } from "./navigation/MobileNav";

export const Navigation = () => {
  return (
    <header className="w-full py-4 px-6 flex items-center justify-between bg-white/80 backdrop-blur-sm fixed top-0 z-50 border-b">
      <NavLogo />
      <div className="flex-1 relative">
        <DesktopNav />
      </div>
      <MobileNav />
    </header>
  );
};
